import { render, staticRenderFns } from "./rfq-add.vue?vue&type=template&id=6f586580&scoped=true"
import script from "./rfq-add.vue?vue&type=script&lang=js"
export * from "./rfq-add.vue?vue&type=script&lang=js"
import style0 from "./rfq-add.vue?vue&type=style&index=0&id=6f586580&prod&scoped=true&lang=css"
import style1 from "./rfq-add.vue?vue&type=style&index=1&id=6f586580&prod&lang=css"
import style2 from "./rfq-add.vue?vue&type=style&index=2&id=6f586580&prod&scoped=true&lang=css"
import style3 from "./rfq-add.vue?vue&type=style&index=3&id=6f586580&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f586580",
  null
  
)

export default component.exports